module.exports = __webpack_public_path__ + "static/Electra-31854c55d3d893d79c69dcb0a6211aa7.pdf";